import React from 'react';

import BlogPosts from '../../../components/BlogPosts';
import { LandingCta, LandingSection, LandingSectionHeader } from '../../components';

function GuidesSection() {
  return <LandingSection>
    <LandingSectionHeader eyebrow="Integration Guides To" title="Build With GoldAPI.io Today" description="Practical guides for WordPress, Shopify, Excel, Joomla, and Drupal." />
    <BlogPosts items={20} />
    <LandingCta />
  </LandingSection>;
}

export default GuidesSection;
